/**
 * Format an ISO date string (or date-only string) to DD.MM.YYYY display format.
 *
 * @param {string|null|undefined} isoDate - ISO 8601 date string, e.g. "2024-03-15" or "2024-03-15T12:00:00Z"
 * @returns {string} Formatted date string (e.g. "15.03.2024"), or empty string for falsy input
 */
export function formatDate(isoDate) {
  if (!isoDate) return '';
  const dateOnly = isoDate.split('T')[0];
  const [year, month, day] = dateOnly.split('-');
  return `${day}.${month}.${year}`;
}
